// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label,
table {
  margin: 0;
  padding: 0;
}
.container {
  width: 100%;
  margin: 0;
  padding: 0;
  margin-bottom: 15px;
}
.setting-header {
  font-size: 18px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.settings-content {
  margin-left: 15px;
}
.custom-table {
  border: 1px solid #c0c0c0;
  border-collapse: collapse;
  margin-top: 10px;
}
.header-cell {
  border: 1px solid #c0c0c0;
  background-color: #e6e6e6;
  align-items: center;
}
.row-new-setting,
.row-new-setting td {
  background-color: #bddbba !important;
}
.row-updated-setting,
.row-updated-setting td {
  background-color: #c5e4eb !important;
}
.row-deleted-setting,
.row-deleted-setting td {
  background-color: #FFCCCB !important;
}
.icon-column-content {
  align-items: center;
  text-align: center;
}
.icon-column-content a {
  cursor: pointer;
  color: blue;
}
.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon-column-content a {
  color: blue;
}
.icon-container i {
  margin-right: 20%;
}
#wrapper-panel-details tr i,
#wrapper-panel-package-details tr i {
  color: grey;
  visibility: visible;
  background-color: transparent;
}
#wrapper-panel-details tr i:hover,
#wrapper-panel-package-details tr i:hover {
  color: #000;
}
#wrapper-panel-details tr:hover i,
#wrapper-panel-package-details tr:hover i {
  visibility: visible;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/settings.component.less"],"names":[],"mappings":"AAEA;;EACE,SAAA;EACA,UAAA;AAAF;AAGA;EACE,WAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AADF;AAIA;EACE,eAAA;EACA,eAAA;EACA,kBAAA;AAFF;AAIA;EACE,iBAAA;AAFF;AAKA;EACE,yBAAA;EACA,yBAAA;EACA,gBAAA;AAHF;AAMA;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;AAJF;AAOA;;EACE,oCAAA;AAJF;AAOA;;EACE,oCAAA;AAJF;AAOA;;EACE,oCAAA;AAJF;AAOA;EACE,mBAAA;EACA,kBAAA;AALF;AAOA;EACE,eAAA;EACA,WAAA;AALF;AAQA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AANF;AASA;EACE,WAAA;AAPF;AAUA;EACE,iBAAA;AARF;AAWA;;EACE,WAAA;EACA,mBAAA;EACA,6BAAA;AARF;AAUA;;EACE,WAAA;AAPF;AASA;;EACE,mBAAA;AANF","sourcesContent":["@import \"@mmodal/aura-less-variables/base/_colors.less\";\n\nlabel, table {\n  margin: 0;\n  padding: 0;\n}\n\n.container {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 15px;\n}\n\n.setting-header {\n  font-size: 18px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n.settings-content {\n  margin-left: 15px;\n}\n\n.custom-table {\n  border: 1px solid @aura-color-gray-60;\n  border-collapse: collapse;\n  margin-top: 10px;\n}\n\n.header-cell {\n  border: 1px solid @aura-color-gray-60;\n  background-color: @aura-color-gray-80;\n  align-items: center;\n}\n\n.row-new-setting, .row-new-setting td {\n  background-color: #bddbba !important;\n}\n\n.row-updated-setting, .row-updated-setting td {\n  background-color: #c5e4eb !important;\n}\n\n.row-deleted-setting, .row-deleted-setting td {\n  background-color: #FFCCCB !important;\n}\n\n.icon-column-content {\n  align-items: center;\n  text-align: center;\n}\n.icon-column-content a {\n  cursor: pointer;\n  color: blue;\n}\n\n.icon-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.icon-column-content a {\n  color: blue;\n}\n\n.icon-container i {\n  margin-right: 20%;\n}\n\n#wrapper-panel-details tr i, #wrapper-panel-package-details tr i {\n  color: grey;\n  visibility: visible;\n  background-color: transparent;\n}\n#wrapper-panel-details tr i:hover, #wrapper-panel-package-details tr i:hover {\n  color: #000;\n}\n#wrapper-panel-details tr:hover i, #wrapper-panel-package-details tr:hover i {\n  visibility: visible;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
